import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
var BottomBanner = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  padding: 16px 12px;\n  ", "\n"])), function (_ref) {
  var palette = _ref.theme.palette;
  return "\n    color: ".concat(palette.primary.contrastText, ";\n    background-color: ").concat(palette.primary.dark, ";\n ");
});
BottomBanner.displayName = 'Footer.BottomBanner';
export default BottomBanner;